import React from 'react'
import { Link } from 'react-router-dom'
import OwlCarousel from 'components/owlCarousel/OwlCarousel.jsx'

import carouselOptions from './carouselOptions'

import gameDrive from 'assets/img/stock/botswana/gamedrive.jpg'
import vicFalls3 from 'assets/img/stock/vfalls/vfalls_3.jpg'

export default () => (
    <section className="intro active">

        {/*<!-- Down Arrow -->*/}
        <a href="#contacts" className="down_block go">
            <i className="fa fa-angle-down" />
        </a>

        {/*<!-- Wrapper -->*/}
        <OwlCarousel className="intro_wrapper_no_auto" options={carouselOptions} >

            {/*<!-- Item -->*/}
            <div className="intro_item">
                {/*<!-- Over -->*/}
                <div
                    className="over over_z_index_2"
                    data-opacity="0.3"
                    data-image="images/overlay.png"
                    data-color="#292929"
                />

                <div
                    id="bgndVideo"
                    className="player"
                    data-property="{videoURL:'https://youtu.be/RGjqfk2QNZA',containment:'self', optimizeDisplay: true, showControls: false, autoPlay:true, mute:true, startAt:0, opacity:1}"
                />

                {/*<!-- Image -->*/}
                <div
                    className="into_back image_bck"
                    data-image={gameDrive}
                />

                {/*<!-- Text -->*/}
                <div className="text_content">
                    <div className="intro_text intro_text_cb text-center text_up">
                        <span className="great_title">
                            Experience the "wonder world" in style
                        </span>
                        <span className="great_subtitle">
                            For the ultimate adventure of a lifetime, don’t just dream, get up, pack, and lets get going!
                        </span>
                    </div>
                </div>
            </div>

            {/*<!-- Item -->*/}
            <div className="intro_item">
                {/*<!-- Over -->*/}
                <div className="over" data-opacity="0.4" data-color="#000" />

                {/*<!-- Image -->*/}
                <div
                    className="into_back image_bck"
                    data-image={vicFalls3}
                />

                {/*<!-- Text -->*/}
                <div className="text_content">
                    <div className="intro_text intro_text_cb text-center text_up">
                        <span className="great_title">
                            Are you ready
                            {' '}
                            <br />
                            for the adventure of a lifetime
                        </span>
                        <span className="great_subtitle great_subtitle_big">
                            Make unforgettable memories
                        </span>
                        <span>
                            <Link to="/itinerary-overview" className="btn btn-white">Full itinerary</Link>
                        </span>
                    </div>
                </div>
            </div>

        </OwlCarousel>
        {/*<!-- Wrapper End -->*/}

    </section>
);



// WEBPACK FOOTER //
// ./src/pages/home/components/videoIntro/VideoIntro.jsx